import { toFloatInt } from 'helpers/NumberFormats';
import { createProductIdentifiersProto } from 'helpers/analytics';

/**
  * https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/AddToFavorites.proto
  *
  * @param {string} productIdentifiers - Keys: productId, styleId, colorId, stockId, asin
  * @param {integer/float} price - price with cents, ex: 10.99. toFloatInt in helpers/NumbersFormats.js
  * may be of use.
  * @param {bool} incompleteAddToFavorites - Add to cart clicked without size/width/some option selected. Empty if add to cart doesn't fail. Bool determines if add to cart occurred or not. Dimension indicates which dimension was not selected.
  * @param {string} missingDimension - see WebsiteEnums.proto for ProductDimension values.
  * Current values are: UNKNOWN_PRODUCT_DIMENSION, SIZE_DIMENSION, WIDTH_DIMENSION, INSEAM_DIMENSION
  * @param {string} addedFrom - see WebsiteEnums.proto for PageType values. Examples:
  * SEARCH_PAGE, PRODUCT_PAGE, HOMEPAGE, LANDING_PAGE, CART_PAGE, CHECKOUT_PAGE
*/
export const evAddToFavorites = ({ productId, styleId, colorId, stockId, asin, price, incompleteAddToFavorites, missingDimension, addedFrom }) => ({
  addToFavorites: {
    productIdentifiers: {
      productId,
      styleId,
      colorId,
      stockId,
      asin
    },
    price: price ? toFloatInt(price) : undefined,
    incompleteAddToFavorites,
    missingDimension,
    addedFrom
  }
});

// https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/FavoritesPageView.proto
export const pvFavorites = hearts => ({
  favoritesPageView: {
    itemsInFavorites: hearts.length,
    favoritedProducts: createProductIdentifiersProto(hearts)
  }
});

// https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/ProductClickthrough.proto
export const evProductClickthrough = ({ asin, productId, styleId, colorId, stockId }) => ({
  productClickthrough: {
    clickedProduct: {
      asin,
      productId,
      styleId,
      colorId,
      stockId
    },
    sourcePage: 11 // pageType as defined https://code.amazon.com/packages/AmethystEvents/blobs/faf0f5e028991bc37ab4f812b597685205aa5bfc/--/configuration/include/com/zappos/amethyst/website/WebsiteEnums.proto#L86
  }
});

// https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/ProductNotifyMe.proto
export const evProductNotifyMe = ({ asin, productId, styleId, colorId, stockId }) => ({
  productNotifyMe: {
    productIdentifiers: {
      asin,
      productId,
      styleId,
      colorId,
      stockId
    },
    sourcePage: 11 // pageType as defined https://code.amazon.com/packages/AmethystEvents/blobs/faf0f5e028991bc37ab4f812b597685205aa5bfc/--/configuration/include/com/zappos/amethyst/website/WebsiteEnums.proto#L86
  }
});

// https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/RemoveFromFavorites.proto
export const evRemoveFromFavorites = ({ asin, productId, styleId, colorId, stockId, sourcePage = 11 }) => ({
  removeFromFavorites: {
    productIdentifiers: {
      asin,
      productId,
      styleId,
      colorId,
      stockId
    },
    sourcePage // pageType as defined https://code.amazon.com/packages/AmethystEvents/blobs/faf0f5e028991bc37ab4f812b597685205aa5bfc/--/configuration/include/com/zappos/amethyst/website/WebsiteEnums.proto#L86
  }
});

// https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/SelectSizeButton.proto
export const evSelectSizeButton = ({ asin, productId, styleId, colorId, stockId }) => ({
  selectSizeButton: {
    productIdentifiers: {
      asin,
      productId,
      styleId,
      colorId,
      stockId
    },
    sourcePage: 11 // pageType as defined https://code.amazon.com/packages/AmethystEvents/blobs/faf0f5e028991bc37ab4f812b597685205aa5bfc/--/configuration/include/com/zappos/amethyst/website/WebsiteEnums.proto#L86
  }
});

// https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/AddToCart.proto
export const evAddToCart = ({ asin, price, productId, styleId, colorId, stockId }) => ({
  addToCart: {
    productIdentifiers: {
      asin,
      productId,
      styleId,
      colorId,
      stockId
    },
    price,
    addedFrom: 11 // pageType as defined https://code.amazon.com/packages/AmethystEvents/blobs/faf0f5e028991bc37ab4f812b597685205aa5bfc/--/configuration/include/com/zappos/amethyst/website/WebsiteEnums.proto#L86
  }
});
